import { ApiError } from "../Combined";
import ResultValue from "../Simple/ResultValue";

export default function OCEResults(props) {
    if (props.error) {
        return (
            <div className="row my-2">
                <div className="col">
                    <div className="card">
                        <div className="card-header">
                            OCE Results{(props.serviceMode && ` - ${props.serviceMode}`) || null}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <ApiError error={props.error} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if (props.result) {
        return (<div className="row my-2">
            <div className="col">
                <div className="card">
                    <div className="card-header">
                        OCE Results{(props.serviceMode && ` - ${props.serviceMode}`) || null}
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6">
                                <h4>Claim</h4>
                                <ResultValue label="Claims Processed"
                                    valueClassName="col-8"
                                    labelClassName="align-self-start"
                                    value={`${props.result.claimEdits.processedFlag.value} - ${props.result.claimEdits.processedFlag.description}`} />
                                {Number(props.result.claimEdits.processedFlag.value) === 1 && (
                                    <ResultValue label="Warning:"
                                        labelClassName="align-self-start text-warning"
                                        value="OCE did not process due to the issue above. Edits may be identified if the claim is resubmitted and processed"
                                        valueClassName="text-warning" />
                                )}
                                <ResultValue label="Overall Claim Disposition"
                                    valueClassName="align-self-start"
                                    value={`${props.result.claimEdits.overallDispositionFlag.value} - ${props.result.claimEdits.overallDispositionFlag.description}`} />
                                <div className="fw-500 mt-2">Rejection Reasons</div>
                                {props.result.claimEdits.rejectionReasons.map((r, i) => {
                                    return (
                                        <div key={i} className="my-2">
                                            <ResultValue label="Code" value={r.code} />
                                            <ResultValue label="Description" value={r.description} />
                                        </div>
                                    )
                                })}
                                {props.result.claimEdits.rejectionReasons.length === 0 && <div className="text-muted">No rejection reasons</div>}
                                <div className="fw-500 mt-2">Denial Reasons</div>
                                {props.result.claimEdits.denialReasons.map((r, i) => {
                                    return (
                                        <div key={i} className="my-2">
                                            <ResultValue label="Code" value={r.code} />
                                            <ResultValue label="Description" value={r.description} />
                                        </div>
                                    )
                                })}
                                {props.result.claimEdits.denialReasons.length === 0 && <div className="text-muted">No denial reasons</div>}
                                <div className="fw-500 mt-2">Suspension Reasons</div>
                                {props.result.claimEdits.suspensionReasons.map((r, i) => {
                                    return (
                                        <div key={i} className="my-2">
                                            <ResultValue label="Code" value={r.code} />
                                            <ResultValue label="Description" value={r.description} />
                                        </div>
                                    )
                                })}
                                {props.result.claimEdits.suspensionReasons.length === 0 && <div className="text-muted">No suspension reasons</div>}
                                <div className="fw-500 mt-2">Return to Payer Reasons</div>
                                {props.result.claimEdits.returnToProviderReasons.map((r, i) => {
                                    return (
                                        <div key={i} className="my-2">
                                            <ResultValue label="Code" value={r.code} />
                                            <ResultValue label="Description" value={r.description} />
                                        </div>
                                    )
                                })}
                                {props.result.claimEdits.returnToProviderReasons.length === 0 && <div className="text-muted">No return to payer reasons</div>}
                                <h4 className="mt-2">Lines</h4>
                                {props.result.lineEdits.map((l, lineIndex) => {
                                    return (
                                        <div key={l.lineNumber} className="my-2">
                                            <ResultValue label="Line ID" value={l.lineNumber} />
                                            <ResultValue label="Denial or Rejection"
                                                labelClassName="align-self-start"
                                                valueClassName="col-8"
                                                value={`${l.denialOrRejectionFlag.value} - ${l.denialOrRejectionFlag.description}`} />
                                            <div className="fw-500 mt-2">Procedure Code Edits</div>
                                            {(!l.procedureCodeEdits || l.procedureCodeEdits.length === 0) && <div className="text-muted">No procedure code edits</div>}
                                            {l.procedureCodeEdits.map((pce, index) => {
                                                return (
                                                    <div key={`${l.lineNumber}-${index}-proc-code-edit`}>
                                                        <div>{pce.code} - {pce.description}</div>
                                                    </div>
                                                );
                                            })}
                                            {lineIndex !== props.result.lineEdits.length - 1 && <hr />}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }

    return null;
}